// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

let imgMainFirst = $('.card__main .gallery-top [itemprop="image"]');

let correctFrameHeight = function(){
    $('.card__main .gallery-top iframe').height(imgMainFirst.height());
}

if(imgMainFirst.length){
    if(imgMainFirst.prop('complete')){ 
        correctFrameHeight();
    }else{
        imgMainFirst.on('load',function(){
            correctFrameHeight();
        });
    }
}

let galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 1,
    slidesPerView: 1,
    loop: false,
    freeMode: true,
    loopedSlides: 5, //looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
        830: {
            slidesPerView: 4,
        },

        1025: {
            slidesPerView: 3,
        },

        1140: {
            slidesPerView: 4,
        },

        1320: {
            slidesPerView: 5,
        },

        1440: {
            slidesPerView: 6
        }
    },
});

let galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 0,
    loop: false,
    slidesPerView: 1,
    loopedSlides: 5, //looped slides should be the same
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    },
    thumbs: {
        swiper: galleryThumbs
    }
});


jQuery('.product-slider__hint-close').on('click', function () {
   this.parentNode.classList.add('hidden');
});

/** 
 * vertical slider for "kitchen" card tmpl
 **/

// save all slides for clone
let slides = {};
let slidesThumb = {};

$('.gallery-top-horisontal .swiper-slide', this).each(function(ii){
    let cc = $(this).data('color') || 'all';
    
    if(typeof slides[cc] === "undefined"){
        slides[cc] = [];
    }
    
    slides[cc].push($(this)[0].outerHTML);
});

$('.gallery-thumbs-vertical .swiper-slide', this).each(function(ii){
    let cc = $(this).data('color') || 'all';
    
    if(typeof slidesThumb[cc] === "undefined"){
        slidesThumb[cc] = [];
    }
    
    slidesThumb[cc].push($(this)[0].outerHTML);
});

let imgFirst = $('.kitchenProduct .gallery-top-horisontal .fimg0');

let verticalSlider = function(){
    $('.kitchenProduct .gallery-thumbs-vertical').height(imgFirst.height());

    let galleryThumbsVert = new Swiper('.gallery-thumbs-vertical', {
        direction: "vertical",
        slidesPerView: 2,
        spaceBetween: 30,
        mousewheel: true
    });

    let galleryTopVert = new Swiper('.gallery-top-horisontal', {
        spaceBetween: 0,
        loop: false,
        slidesPerView: 1,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        },
        thumbs: {
            swiper: galleryThumbsVert
        }
    });

    galleryThumbsVert.updateProgress();
};

// init slider if first img height loaded
if(imgFirst.prop('complete')){ 
    verticalSlider();
}else{
    imgFirst.on('load',function(){
        verticalSlider();
    });
}

// change color, update img slider
$('.modular-colors-wrap [data-color]').on('click', function(e){
    let swiper = document.querySelector('.gallery-top-horisontal').swiper,
        swiperThumb = document.querySelector('.gallery-thumbs-vertical').swiper,
        color = $(this).data('color'),
        allSlides = [];
    
    $('.modular-colors-wrap .kitchenProduct-color-wrapp div').removeClass('border-primary');
    $(this).addClass('border-primary');

    swiper.removeAllSlides();
    swiperThumb.removeAllSlides();

    // update main slides
    if(typeof slides.all !== 'undefined')
        allSlides = slides.all;
    if(typeof slides[color] !== 'undefined')
        allSlides = [...allSlides, ...slides[color]];

    swiper.addSlide(0, allSlides);
    swiper.updateProgress();
    swiper.slideTo(0, 500, false);

    // update thumbs slides
    allSlides = [];
    if(typeof slidesThumb.all !== 'undefined')
        allSlides = slidesThumb.all;
    if(typeof slidesThumb[color] !== 'undefined')
        allSlides = [...allSlides, ...slidesThumb[color]];

    swiperThumb.addSlide(0, allSlides);
    swiperThumb.updateProgress();
    swiperThumb.slideTo(0, 500, false);
});